import { useDownloadFile } from './fileDownload';

export const useDownloadZip = () => {
  const { download, isError, isLoading } = useDownloadFile();

  return {
    download: (urlPath: string, filename: string) =>
      download(urlPath, `${filename}.zip`, 'application/zip'),
    isError,
    isLoading,
  };
};
